import type { AddressClient } from '@/api/modules/addresses/addresses.types'

interface AddressFormatOptions {
  street?: boolean
  house?: boolean
}

/**
 * Формирование полной строки адреса
 * @param address - поля адреса
 * @param border - граница формирования адреса
 */
export const formatToFullVisibleAddress = (
  address: AddressClient,
  border: AddressFormatOptions = {
    street: true,
    house: true,
  },
): string => {
  const { street, locality, house, flat, city } = address

  let result = ''

  // Приводим к нижнему регистру
  const loverLocality = locality ? locality.toLocaleLowerCase() : null

  // Если locality существует и не равен улице и городу
  const isNeedAddLocality =
    Boolean(loverLocality) &&
    loverLocality !== street.toLocaleLowerCase() &&
    loverLocality !== city.toLocaleLowerCase()

  if (isNeedAddLocality) result = locality

  // Если locality есть
  if (result) result += `, `

  result += `${street}`

  if (!border.street) return result

  if (house) result += ` д. ${house}`

  // Флаг определяющий литерал адреса до номера дома
  if (!border.house) return result

  if (flat) result = `${result}, кв ${flat}`

  return result
}

/**
 * Формирование адреса в формате 'Город, Улица, Дом'
 */
export const formatToAddressSystem = (
  city: string,
  street: string,
  house: string,
) => {
  // Массив для хранения компонентов адреса
  const addressParts = []

  // Добавляем компоненты, если они существуют
  if (city) addressParts.push(city)
  if (street) addressParts.push(street)
  if (house) addressParts.push(house)

  // Собираем строку, разделяя компоненты запятой
  return addressParts.join(', ')
}
